var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2462 46.6876C69.7647 44.4121 70.0164 42.0839 69.9962 39.7501C69.8712 23.2189 56.1837 9.84388 39.6837 10.0001C32.6348 10.0745 25.8371 12.6287 20.4834 17.2147C15.1298 21.8006 11.562 28.1254 10.4061 35.0794C9.25022 42.0333 10.5801 49.1722 14.1623 55.2435C17.7445 61.3148 23.3504 65.9307 29.9962 68.2814C31.1267 68.6886 32.3388 68.8171 33.5296 68.6559C34.7204 68.4947 35.8546 68.0486 36.8362 67.3554C37.8177 66.6622 38.6175 65.7424 39.1676 64.6741C39.7177 63.6058 40.002 62.4205 39.9962 61.2189V60.0001C39.9921 59.0141 40.1833 58.0369 40.5587 57.1251C40.9342 56.2133 41.4865 55.3849 42.1837 54.6876C42.881 53.9904 43.7094 53.4381 44.6212 53.0626C45.533 52.6872 46.5102 52.496 47.4962 52.5001H61.9337C63.6304 52.5012 65.2772 51.927 66.6054 50.8713C67.9335 49.8156 68.8645 48.3408 69.2462 46.6876V46.6876Z",
    stroke: "#FCC310",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1875 25C46.1875 27.7269 43.9769 29.9375 41.25 29.9375C38.5231 29.9375 36.3125 27.7269 36.3125 25C36.3125 22.2731 38.5231 20.0625 41.25 20.0625C43.9769 20.0625 46.1875 22.2731 46.1875 25Z",
    fill: "#FCC310",
    stroke: "#FCC310",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 33.125C32.125 35.8519 29.9144 38.0625 27.1875 38.0625C24.4606 38.0625 22.25 35.8519 22.25 33.125C22.25 30.3981 24.4606 28.1875 27.1875 28.1875C29.9144 28.1875 32.125 30.3981 32.125 33.125Z",
    fill: "#FCC310",
    stroke: "#FCC310",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 49.375C32.125 52.1019 29.9144 54.3125 27.1875 54.3125C24.4606 54.3125 22.25 52.1019 22.25 49.375C22.25 46.6481 24.4606 44.4375 27.1875 44.4375C29.9144 44.4375 32.125 46.6481 32.125 49.375Z",
    fill: "#FCC310",
    stroke: "#FCC310",
    strokeWidth: 0.125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.25 33.125C60.25 35.8519 58.0394 38.0625 55.3125 38.0625C52.5856 38.0625 50.375 35.8519 50.375 33.125C50.375 30.3981 52.5856 28.1875 55.3125 28.1875C58.0394 28.1875 60.25 30.3981 60.25 33.125Z",
    fill: "#FCC310",
    stroke: "#FCC310",
    strokeWidth: 0.125
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.c2fedca8821b7bb5af1f90cfa5b2d2ca.svg";
export { ForwardRef as ReactComponent };